// extracted by mini-css-extract-plugin
export default {"page_con":"styles_page_con__XjgtB","btn":"styles_btn__EL8Km","load":"styles_load__+-iDJ","not_found_svg":"styles_not_found_svg__iIcqt"};